"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SecureBookingButton;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _api = require("@whitbread-eos/api");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _nextI18next = require("next-i18next");
var _react2 = require("react");
var _PageLoader = _interopRequireDefault(require("../PageLoader"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SecureBookingButton(_ref) {
  var _data$area, _hiData$hotelInformat;
  var {
    data
  } = _ref;
  var [pageLoaderStatus, setPageLoaderStatus] = (0, _react2.useState)(false);
  var {
    [_api.FT_PI_BB_NON_GUARANTEED_REMINDER]: isFeatureEnabled
  } = (0, _utils.useFeatureToggle)();
  var {
    language,
    country
  } = (0, _utils.useCustomLocale)();
  var {
    t
  } = (0, _nextI18next.useTranslation)();
  var {
    basketReference,
    hotelInfo
  } = data;
  var bookingFlowId = hotelInfo === null || hotelInfo === void 0 ? void 0 : hotelInfo.bookingFlowId;
  var isItPremInOrBusiBooker = (data === null || data === void 0 ? void 0 : data.area) === _api.Area.BB || (data === null || data === void 0 ? void 0 : data.area) === _api.Area.PI;
  var {
    isLoading: isLoadingHotelInformation,
    data: hiData
  } = (0, _utils.useQueryRequest)(['GetHotelInformation', hotelInfo === null || hotelInfo === void 0 ? void 0 : hotelInfo.hotelId, country, language], _api.GET_HOTEL_INFORMATION, {
    hotelId: hotelInfo === null || hotelInfo === void 0 ? void 0 : hotelInfo.hotelId,
    country,
    language
  }, {
    enabled: !!isItPremInOrBusiBooker
  });
  var isBookingInformationEnabled = !isLoadingHotelInformation && !!hiData && !bookingFlowId && !!isItPremInOrBusiBooker;
  var {
    data: bkngData
  } = (0, _utils.useQueryRequest)(['GetBookingInformation', language, country, basketReference], _api.GET_BOOKING_INFORMATION, {
    basketReference,
    language,
    country,
    bookingChannelCriteria: {
      channel: data === null || data === void 0 || (_data$area = data.area) === null || _data$area === void 0 ? void 0 : _data$area.toUpperCase(),
      subchannel: 'WEB',
      language
    }
  }, {
    enabled: !!isBookingInformationEnabled
  });
  if (!bookingFlowId) {
    var _bkngData$bookingInfo;
    bookingFlowId = bkngData === null || bkngData === void 0 || (_bkngData$bookingInfo = bkngData.bookingInformation) === null || _bkngData$bookingInfo === void 0 ? void 0 : _bkngData$bookingInfo.bookingFlowId;
  }
  var hotelBrand = hiData === null || hiData === void 0 || (_hiData$hotelInformat = hiData.hotelInformation) === null || _hiData$hotelInformat === void 0 ? void 0 : _hiData$hotelInformat.brand;
  var displayButton = !isLoadingHotelInformation ? (0, _utils.shouldDisplaySecureBooking)(data, hotelBrand, isFeatureEnabled) : false;
  var baseTestId = 'SecureBooking';
  var isBusinessBooker = (data === null || data === void 0 ? void 0 : data.area) === _api.Area.BB;
  return displayButton && (0, _jsxRuntime.jsxs)(_react.Grid, _objectSpread(_objectSpread({}, gridStyles), {}, {
    children: [(0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({}, contentWrapperStyle), {}, {
      children: [(0, _jsxRuntime.jsx)(_react.Flex, _objectSpread(_objectSpread({}, iconColumnStyle), {}, {
        children: (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, iconWrapperStyle), {}, {
          children: (0, _jsxRuntime.jsx)(_atoms.Lock, {
            width: "48"
          })
        }))
      })), (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({}, textWrapperStyle), {}, {
        children: [(0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, headingTextStyle), {}, {
          children: t('nonguaranteed.booking.arrivingAfter6pm')
        })), (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, subTextStyle), {}, {
          children: t('nonguaranteed.booking.secureByCard')
        }))]
      }))]
    })), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, amendButtonStyleWrapper), {}, {
      children: (0, _jsxRuntime.jsx)(_react.Button, _objectSpread(_objectSpread({}, amendButtonStyle(language)), {}, {
        "data-testid": (0, _utils.formatDataTestId)(baseTestId, 'Button'),
        onClick: () => handleOnClick(basketReference, country, language, setPageLoaderStatus, bookingFlowId, isBusinessBooker),
        children: t('nonguaranteed.booking.buttonlabel')
      }))
    })), !!pageLoaderStatus && (0, _jsxRuntime.jsx)(_PageLoader.default, {
      text: t('searchresults.list.hotel.loading')
    })]
  }));
}
function handleOnClick(basketReference, country, language, setPageLoaderStatus) {
  var bookingFlowId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var isBusinessBooker = arguments.length > 5 ? arguments[5] : undefined;
  setPageLoaderStatus(true);
  var envPath = isBusinessBooker ? '/business-booker/booking-business/' : "/".concat(bookingFlowId, "/");
  var targetUri = "/".concat(country, "/").concat(language).concat(envPath, "payment?reservationId=").concat(basketReference, "&secure-booking=true");
  if (typeof window !== 'undefined') {
    window.location.href = targetUri;
  }
}
var gridStyles = {
  templateColumns: {
    base: '1fr',
    md: '1fr auto'
  },
  gap: 'lg',
  p: 'lg',
  alignItems: 'center',
  border: '1px solid var(--chakra-colors-lightGrey2)',
  borderRadius: 'md',
  w: 'full',
  mx: 'auto',
  mb: {
    base: 'lg',
    md: '10%'
  }
};
var contentWrapperStyle = {
  direction: {
    base: 'column',
    md: 'row'
  },
  gap: 4,
  align: 'bottom',
  w: '100%'
};
var iconColumnStyle = {
  align: 'center',
  justifyContent: 'flex-start',
  display: {
    base: 'none',
    md: 'flex'
  }
};
var iconWrapperStyle = {
  py: 0,
  pr: 0
};
var textWrapperStyle = {
  direction: 'column',
  justify: 'center',
  flex: 1
};
var headingTextStyle = {
  fontWeight: 'bold',
  fontSize: 'xl',
  lineHeight: '120%',
  letterSpacing: '0%',
  color: {
    base: 'inherit',
    md: 'var(--chakra-colors-btnSecondaryEnabled)'
  },
  pb: 'sm'
};
var subTextStyle = {
  fontSize: 'normal',
  lineHeight: '150%',
  letterSpacing: '0%',
  color: 'var(--chakra-colors-darkGrey1)'
};
var amendButtonStyleWrapper = {
  w: {
    base: '100%',
    md: 'auto'
  },
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignSelf: 'stretch'
};
var amendButtonStyle = language => {
  return {
    fontSize: 'lg',
    fontWeight: 'semibold',
    lineHeight: '3',
    size: 'sm',
    variant: 'primary',
    w: {
      base: '100%',
      lg: language === 'de' ? '18rem' : '15.5rem'
    },
    borderRadius: '4px'
  };
};